// extracted by mini-css-extract-plugin
export default {"selectStyles":"pure-select_selectStyles__jl5X1"};